// TODO: FCSE-7093 - Replace hardcoded values with constants
export const AddonProduct = {
  PAYMENT_PROTECTION_INSURANCE: 'PAYMENT_PROTECTION_INSURANCE',
  ID_PROTECT: 'ID_PROTECT',
} as const;

export type AddonProducts = (typeof AddonProduct)[keyof typeof AddonProduct];
